/* eslint-disable */
import React from 'react'

const ArrowSecondary = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 10 7"
  >
    <defs>
      <path
        id="a"
        d="M5 6.588a.919.919 0 01-.651-.261L.219 1.289C-.1.969-.067.479.292.195a.944.944 0 011.228.067L5 4.643 8.48.263A.945.945 0 019.706.194c.36.283.393.774.075 1.094l-4.13 5.038A.919.919 0 015 6.588"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-373 -791)">
        <g transform="translate(273 781)">
          <g transform="translate(100 10)">
            <mask fill="#fff">
              <use xlinkHref="#a"></use>
            </mask>
            <use fill="#92929E" xlinkHref="#a"></use>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default ArrowSecondary
